import React from "react";
import {
  createDoc,
  deleteDocById,
  deleteDocByRef,
  deleteDocDataField,
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDateFromSeconds,
  getDocDataById,
  getDocDataByRef,
  getFlutterTimeFromSeconds,
  getRefFromId,
  getUserDataById,
  queryCollection,
  updateDocDataField,
} from "../models/DataFunctions";
import { useEffect, useState } from "react";
import Icon1 from "../icons/Icon";
import { Timestamp } from "firebase/firestore";
import TextField2 from "../textfields/TextField2";
import TextField3 from "../textfields/TextField3";
import PrimaryButton from "../buttons/PrimaryButton";
import SecondaryButton from "../buttons/SecondaryButton";
import Space from "../layout/Space";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import modifyEvent from "../api/modify/modifyEvent";
import { useSnackbar } from "notistack";
import { DatePicker, TimePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { useAppContext } from "../config/AppContext";
import Modal1 from "../modals/Modal1";
import Control from "./Control";
import SmallSpinner from "../loading/SmallSpinner";
import DropDownGPT1 from "../dropdowns/DropDownGPT1";
import DropDownGPTMulti from "../dropdowns/DropDownGPTMulti";
import MLTF1 from "../textfields/MLTF1";
import MLTFGPT1 from "../textfields/MLTFGPT1";
import { set } from "date-fns";
import WarningButton from "../buttons/WarningButton";
import {
  getFoldersByOrgRef,
  getOrgById,
  isArchived,
} from "../models/OrgFunctions";
import { Switch } from "@mui/material";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import createDocApi from "../api/database/createDocApi";
import { Player } from "@lottiefiles/react-lottie-player";
import loadingAnimation from "../animations/loading.json"; // Path to your JSON file
import NewMission from "../oecvmc/NewMission";
import sendConformityReport from "../api/send/sendConformityReport";
import { ca, id } from "date-fns/locale";
import Tippy from "@tippyjs/react";
import Revisite from "../folder_modals/Revisite";
import TimePickerGPT0 from "../textfields/TimePickerGPT0";
import RangeTimePickerGPT0 from "../textfields/RangeTimePickerGPT0";
import NotesClient from "../notes/NotesClient";
import DropDownGPT1X from "../dropdowns/DropDownGPT1X";
import TextField2T from "../textfields/TextField2T";
import DropDownGPTS3 from "../dropdowns/DropDownGPTS3";
import DropDownGPT03 from "../dropdowns/DropDownGTP03";
import DatePickerGPT0 from "../textfields/DatePickerGPT0";
import DropDownGPTM3 from "../dropdowns/DropDownGPTM3";
import EmailModal from "../modals/EmailModal";
import SMSReminderModal from "../modals/SMSReminderModal";
import { EasySwitch } from "../textfields/EasySwitch";
import getControlPresginedUrls from "../api/presigned/getControlPresignedUrls";
import fixControlLinksApi from "../api/database/fixControlLinksApi";
import { isEventAdmin } from "../hexagone/VisibilityHelpers";
import updateDocApi from "../api/database/updateDocApi";
import SearchAlgolia from "../textfields/SearchAlgolia";
import { queryCollectionAlgolia } from "../models/AlgoliaFunctions";
import deleteGoogleCalendarEvent from "../api/modify/deleteGoogleCalendarEvent";
import Conformity from "../folder_modals/Conformity";
import { findEmojiofPartner } from "../pages/Partner";
import { handleFetchPacksBasedOnFolderType } from "../pages/folder_pages/NewFolder";
import ConfirmationModal from "../modals/ConfirmationModal";

const Event = ({
  parsed_date,
  event_id,
  setEvent,
  orgData,
  userData,
  onCloseEvent,
  onDelete,
  onUpdate,
  setCannotClose,
  workspaceData,

  navigateWorkspace,
  temporary,
  setTemporary,
}) => {
  const [members, setMembers] = useState([]);
  const [modify, setModify] = useState(false);
  const [event, setEventData] = useState();
  const [titre_value, setTitre_value] = useState(event?.name);
  const [confirm_delete_open, setDeleteConfirmOpen] = useState(false);

  const [name, setName] = useState("");
  const [adresse, setAdresse] = useState("");
  const [ville, setVille] = useState("");
  const [postal, setPostal] = useState("");
  const [pack_name, setPack_name] = useState("");
  const [all_clients, setAll_clients] = useState([]);
  const [all_folders, setAll_folders] = useState([]);
  const [all_members, setAll_members] = useState([]);
  const [email_open, setEmailOpen] = useState(false);
  const [masterData, setMasterData] = useState(null);
  const [event_frequency, setEventFrequency] = useState(null);

  const [clients_options, setClients_options] = useState([]);
  const [conductor_options, setConductor_options] = useState([]);
  const [selected_conductor, setSelected_conductor] = useState(null);
  const [pack_options, setPack_options] = useState([]);

  const [folders_options, setFolders_options] = useState([]);
  const [members_options, setMembers_options] = useState([]);
  const [clientmember, setClientmember] = useState(null);

  const [selected_client, setSelected_client] = useState(null);
  const [selected_folder, setSelected_folder] = useState(null);
  const [selected_members, setSelected_members] = useState([]);
  const [selected_pack, setSelected_pack] = useState(null);

  const [selected_members_objects, setSelected_members_objects] = useState([]);
  const [selected_client_idbject, setSelected_client_idbject] = useState(null);
  const [workspace, setWorkspace] = useState(null);
  const [selected_folder_object, setSelected_folder_object] = useState(null);
  const [datetime, setDatetime] = useState("vide");
  const [description, setDescription] = useState("");

  const [loading, setLoading] = useState(true);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [folderModalOpen, setFolderModalOpen] = useState(false);

  const [selected_event_type, setSelected_event_type] = useState(null);
  const [event_type_options, setEvent_type_options] = useState([
    {
      value: "Intervention",
      label: "Intervention",
    },
    {
      value: "Pause déjeuner",
      label: "Pause déjeuner",
    },
    {
      value: "Réunion technique",
      label: "Réunion technique",
    },
    {
      value: "Rendez-vous autre",
      label: "Rendez-vous autre",
    },
    {
      value: "Rendez-vous privé",
      label: "Rendez-vous privé",
    },
    {
      value: "Appel client",
      label: "Appel client",
    },
    {
      value: "Congés",
      label: "Congés",
    },
    {
      value: "Repos hebdomadaire",
      label: "Repos hebdomadaire",
    },
    {
      value: "Récup HS",
      label: "Récup HS",
    },
    {
      value: "Bureau",
      label: "Bureau",
    },
    {
      value: "Trajet",
      label: "Trajet",
    },
    {
      value: "Ferié",
      label: "Ferié",
    },
    {
      value: "Fermé",
      label: "Fermé",
    },
    {
      value: "Créé par Google",
      label: "Créé par Google",
    },
  ]);

  const [documents_completed, setDocuments_completed] = useState([]);
  const [rdv_confirmed, setRdv_confirmed] = useState(false);
  const [cancelled, setCancelled] = useState(false);

  const setInfosFromFolder = async () => {
    console.log("Setting infos from folder", selected_folder);
    if (!selected_folder) return;
    if (selected_folder) {
      const folderdata = await getDocDataById("folder", selected_folder);

      setSelected_folder_object(folderdata);
      if (folderdata.client_type !== "particulier") {
        const client = await getOrgById(folderdata.client_id);
        setSelected_client_idbject(client);

        setSelected_client(client.id);
      }
      if (folderdata.conductor_id) {
        const clientmember = await getUserDataById(folderdata.conductor_id);
        console.log("Client member found:", clientmember);
        if (clientmember) {
          setClientmember(clientmember);
          setSelected_conductor(clientmember.id);
        } else {
          handleClickVariant(
            "Le conducteur de chantier n'existe plus - sa référence a donc été retirée du dossier.",
            "error"
          );
          await updateDocDataFieldApi(
            folderdata.ref,
            "conductor_id",
            null,
            prefix
          );
        }
      }
      setName(folderdata.nom);
      setVille(folderdata.ville);
      setPostal(folderdata.postal);
    }
  };

  const [selectedDateSeconds, setSelectedDateSeconds] = useState(null);

  const [rangeTime, setRangeTime] = useState({
    start_seconds: null,
    end_seconds: null,
  });

  const handleTimeRangeChange = (timeRange) => {
    if (timeRange) {
      setRangeTime(timeRange);
    }
  };
  useEffect(() => {
    setInfosFromFolder();
  }, [selected_folder]);

  const onDateTimeChange = (date, hour1, hour2, minute1, minute2) => {
    setDatetime({
      date: date,
      hour1: hour1,
      hour2: hour2,
      minute1: minute1,
      minute2: minute2,
    });
  };

  const handleSetFolder = async (newValue) => {
    if (newValue === null) {
      setSelected_folder(null);
      setSelected_folder_object({});
      return;
    }

    setSelected_folder(newValue);
    const folder_obj = await getDocDataById("folder", newValue);
    setSelected_folder_object(folder_obj);
    if (folder_obj && folder_obj.client_type !== "particulier") {
      const client = await getOrgById(folder_obj.client_id);
      setSelected_client(client.id);
      setSelected_client_idbject(client);
      let workspaces = await getArrayDocDataByID(
        "workspace",
        client.workspaces_id
      );
      let workspace = workspaces.find(
        (workspace) => workspace.master_id === orgData.id
      );
      console.log("Workspace found:", workspace);
      setWorkspace(workspace);
    } else {
      setSelected_client(null);
      setSelected_client_idbject({});
    }
    setSelected_event_type("Intervention");
    if (folder_obj) {
      let masterData = await getOrgById(folder_obj.master_id);
      setVille(folder_obj.ville);
      setPostal(folder_obj.postal);
      setAdresse(folder_obj.adresse);
      setName(folder_obj.nom);
      setSelected_members_objects(
        masterData.users_id.length === 1
          ? masterData.users_id
          : members.filter((member) =>
              folder_obj.members_id.includes(member.id)
            )
      );
      setSelected_members(
        masterData.users_id.length === 1
          ? masterData.users_id
          : folder_obj.members_id || []
      );
      setSelected_conductor(folder_obj.conductor_id || null);
      let clientmember = await getUserDataById(folder_obj.conductor_id);
      console.log("Client member found:", clientmember);
      clientmember && setClientmember(clientmember);
      setConductor_options([
        {
          value: folder_obj.conductor_id,
          label: clientmember?.display_name || "",
        },
      ]);
      setPack_name(folder_obj.pack_name);
      setSelected_pack(folder_obj.pack);
    } else {
      setVille(event?.ville);
      setPostal(event?.postal);
      setAdresse(event?.adresse);
      setName(event?.name);
      setPack_name(event?.pack_name);
      setSelected_pack(event?.pack_ref?.id);
      setSelected_members_objects([]);
    }
  };

  const handleFetchData = async (modify = null) => {
    setCan_fetch(false);
    const event = await getDocDataById("event", event_id);
    if (!event) {
      console.error("Event not found with id", event_id);
      onCloseEvent();
      return;
    }
    setEventData(event);

    // Cron-free link detection: count this event's controls directly from
    // control.event_id (always current). Falls back to the legacy eventref
    // query. The denormalized event.controls_count/cid (kept by the reconcile
    // cron) remain a secondary fallback in the gating below.
    (async () => {
      try {
        let evControls = await queryCollection("control", [
          { field: "event_id", operator: "==", value: event_id },
        ]);
        if (!evControls || evControls.length === 0) {
          evControls = await queryCollection("control", [
            {
              field: "eventref",
              operator: "==",
              value: getRefFromId("event", event_id),
            },
          ]);
        }
        setEventControlsCount((evControls || []).length);
      } catch (e) {
        setEventControlsCount(null);
      }
    })();

    setSelected_event_type(
      event?.type !== "" && event?.type !== undefined ? event?.type : null
    );
    setEventFrequency(event?.frequency);

    const start_timestamp = event?.start;
    const end_timestamp = event?.end;

    const start_date = moment.unix(start_timestamp.seconds); // Create moment from Unix timestamp
    const end_date = moment.unix(end_timestamp.seconds); // Same for end date

    // Extract hours and minutes
    const new_start_hour = start_date.hours();
    const new_end_hour = end_date.hours();
    const new_start_min = start_date.minutes();
    const new_end_min = end_date.minutes();

    // Format date for display
    const date = start_date.format("DD/MM/YYYY");

    // Set datetime state
    setDatetime({
      date: date,
      hour1: new_start_hour,
      hour2: new_end_hour,
      minute1: new_start_min,
      minute2: new_end_min,
    });

    setDocuments_completed(event?.documents_completed || false);
    setRdv_confirmed(event?.rdv_confirmed || false);
    setCancelled(event?.cancelled || false);

    if (event?.name === "" && isEventAdmin(orgData, event)) {
      setModify(modify !== null ? modify : true);
      setCannotClose(modify === false ? false : true);
    }
    let seconds = start_date.unix();

    if (
      [
        "daily",
        "weekly",
        "weekly2",
        "weekly3",
        "monthly",
        "weekly5",
        "weekly6",
      ].includes(event?.frequency || null)
    ) {
      // we need to get the actual selected week and deduce the date
      const selected_week = event?.frequency;
      let clicked_date = moment(parsed_date, "DD/MM/YYYY");
      start_date.set("date", clicked_date.date());
      start_date.set("month", clicked_date.month());
      start_date.set("year", clicked_date.year());
      start_date.set("hours", 0);
      start_date.set("minutes", 0);
      start_date.set("seconds", 0);
      let seconds = start_date.unix();
      setSelectedDateSeconds(seconds);
    } else {
      start_date.set("hours", 0);
      start_date.set("minutes", 0);
      start_date.set("seconds", 0);
      let seconds = start_date.unix();
      setSelectedDateSeconds(seconds); // Directly use the moment
    }
    // Set selectedDate, selectedTime, and selectedTime2
    setDescription(event?.description);

    // i want to extract date and moinute from  event.start.seconds
    const start_date_obj = new Date(event.start.seconds * 1000);
    const end_date_obj = new Date(event.end.seconds * 1000);

    // no I want only hours + minutes in seconds
    const start_hour = start_date_obj.getHours();
    const start_minute = start_date_obj.getMinutes();
    const end_hour = end_date_obj.getHours();
    const end_minute = end_date_obj.getMinutes();
    const start_date_seconds = start_hour * 3600 + start_minute * 60;
    const end_date_seconds = end_hour * 3600 + end_minute * 60;
    let range = {
      start_seconds: start_date_seconds,
      end_seconds: end_date_seconds,
    };

    setRangeTime(range);
    if (event?.client_id) {
      const client = await getOrgById(event?.client_id);

      if (client) {
        setSelected_client_idbject(client);
        let workspaces = await getArrayDocDataByID(
          "workspace",
          client.workspaces_id || []
        );
        let workspace = workspaces.find(
          (workspace) => workspace.master_id === orgData.id
        );
        setWorkspace(workspace);
        setSelected_client(client.id);

        const client_users = await getArrayDocDataByID(
          "user",
          client.users_id || []
        );
        const client_conductors = client_users.filter(
          (user) => user.role === "conductor"
        );

        setConductor_options(
          client_conductors.map((user) => ({
            value: user.id,
            label: user.display_name,
          }))
        );
      }
    }
    setName(event?.name);

    if (event?.conductor_id) {
      const clientmember = await getUserDataById(event.conductor_id);
      if (clientmember) {
        setSelected_conductor(clientmember.id);
      } else {
        handleClickVariant("Le conducteur de chantier n'existe pas", "error");
      }
    }
    let masterData = null;
    masterData = await getOrgById(event?.master_id);
    setMasterData(masterData);
    console.log("Event members:", event?.members_id);
    if (event?.folder) {
      console.log("Event folder:", event?.folder);
      const folderdata = await getDocDataByRef(event?.folder);
      console.log("Folder data:", folderdata);
      if (folderdata) {
        setSelected_folder(folderdata.id);
        setSelected_folder_object(folderdata);
        console.log("Folder data:", folderdata);
        setSelected_pack(folderdata.pack);
        console.log("Folder pack:", folderdata.pack);
        setPack_name(folderdata.pack_name);

        if (folderdata.conductor_id) {
          const clientmember = await getUserDataById(folderdata.conductor_id);
          if (clientmember) {
            setClientmember(clientmember);

            setSelected_conductor(clientmember.id);
          } else {
            handleClickVariant(
              "Le conducteur de chantier n'existe pas",
              "error"
            );
          }
        }
      }
    } else {
      setName(event?.name);
      setAdresse(event?.adresse);
      setVille(event?.ville);
      setPostal(event?.postal);
      setPack_name(event?.pack_name);
      setSelected_pack(event?.pack_ref?.id);
      let most_recently_created_folders = await queryCollection(
        "folder",
        [
          {
            field: "master_id",
            operator: "==",
            value: orgData.id,
          },
        ],
        5,
        "created_time",
        "desc"
      );
      setAlgoliaResults(
        most_recently_created_folders.map((folder) => ({
          nom: folder.nom,
          objectID: folder.id,
          marque: folder.marque || "",
          ville: folder.ville || "",
        }))
      );
    }

    if (event?.members_id) {
      const membersData =
        (await getArrayDocDataByID("user", event?.members_id || [])) || [];

      setSelected_members_objects(membersData);
      setSelected_members(membersData.map((member) => member.id));
    }

    setLoading(false);

    if (isEventAdmin(orgData, event)) {
      const client_filters = [
        {
          field: "masters_id",
          operator: "array-contains",
          value: orgData.id,
        },
      ];

      const member_filters = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];

      const [all_clients, all_members] = await Promise.all([
        queryCollection("org", client_filters),
        queryCollection("user", member_filters),
      ]);

      let all_folders = [];

      let all_operators = all_members;

      const packs_filters = [
        {
          field: "org_id",
          operator: "==",
          value: orgData.id,
        },
      ];
      let custom_packs = await queryCollection("pack", packs_filters);
      custom_packs = custom_packs.filter((pack) => pack.admin_pack !== true);
      const filters_admin = [
        {
          field: "admin_pack",
          operator: "==",
          value: true,
        },
      ];
      const packs_admin = await queryCollection("pack", filters_admin);
      // lets order by pack_name
      // remove duplicates
      const all_packs = custom_packs.concat(packs_admin);

      const packs = all_packs.sort((a, b) => {
        if (a.admin_pack !== b.admin_pack) {
          return a.admin_pack === true ? -1 : 1;
        }
        return a.pack_name.localeCompare(b.pack_name);
      });

      // sort by pack_name
      const packs_sorted = packs.sort((a, b) =>
        a.pack_name > b.pack_name ? 1 : -1
      );
      const pack_options = packs_sorted.map((pack) => ({
        value: pack.id,
        label: pack?.pack_name,
      }));

      // setPack_options(pack_options);
      await handleFetchPacksBasedOnFolderType(
        setPack_options,
        masterData,
        setSelected_pack
      );
      // Set state after all queries are done
      setAll_clients(all_clients);

      setAll_members(all_operators);

      setClients_options(
        all_clients.map((client) => ({ value: client.id, label: client.name }))
      );
      // sort folders by nom

      setMembers_options(
        all_operators.map((member) => ({
          value: member.id,
          label: member.display_name,
        }))
      );
    }

    if (!event) return;
    setTitre_value(event?.name);
    let client = null;

    setAdresse(event?.address || event?.adresse); //fucked up code
    setVille(event?.ville);
    setPostal(event?.postal);
  };
  const gotoFolder = (folder) => {
    navigateWorkspace(`/folder/${folder.id}`);
  };
  const gotoFolderName = (folder) => {
    // folder_id is folder.value, use this to link event to folder
    if (folder?.value) {
      const folder_id = folder.value;
      navigateWorkspace(`/folder/${folder_id}`);
    } else {
      console.warn("Folder value is not defined:", folder);
    }
  };
  const [searchValue, setSearchValue] = useState("");
  const [algoliaResults, setAlgoliaResults] = useState([]);

  const handleQuerySearch = async (searchTerm) => {
    console.log("Searching Algolia with term:", searchTerm);
    let folders_filters = [
      {
        field: "master_id",
        operator: "==",
        value: orgData.id,
      },
    ];

    let results = await queryCollectionAlgolia(
      "folder",
      folders_filters,
      searchTerm,
      50
    );
    console.log("Results from Algolia:", results);
    setAlgoliaResults(results);
    setSearchValue(searchTerm);
  };
  const handleGoNewFolder = async () => {
    const param_ville = event?.ville ? `&ville=${event?.ville}` : "";
    const param_postal = event?.postal ? `&postal=${event?.postal}` : "";

    const param_adresse = event?.address ? `&adresse=${event?.address}` : "";
    const param_name = event?.name ? `&name=${event?.name}` : "";
    const param_pack_id = selected_pack
      ? `&pack_id=${selected_pack.replace("+", "xwsx5!")}`
      : "";
    const param_client = selected_client ? `&client=${selected_client}` : "";
    const param_members = selected_members
      ? `&members=${selected_members.join(",")}`
      : "";
    const param_conductor = selected_conductor
      ? `&conductor=${selected_conductor}`
      : "";
    const param_start = selectedDateSeconds
      ? `&start=${dayjs.unix(selectedDateSeconds).format("DD/MM/YYYY")}`
      : "";
    const param_event_id = event?.id ? `&eventid=${event?.id}` : "";

    const param = `?${param_ville}${param_postal}${param_adresse}${param_name}${param_pack_id}${param_client}${param_members}${param_conductor}${param_start}${param_event_id}`;
    navigateWorkspace(`/newfolder${param}`);
  };

  const [can_fetch, setCan_fetch] = useState(true);

  useEffect(() => {
    if (can_fetch) {
      handleFetchData();
    } else {
    }
  }, [orgData]);

  const deleteEvent = async () => {
    // For recurring events, check frequency selection first before folder logic
    if (frequency_affect === null && event?.frequency) {
      setFrequencyDeleteModalOpen(true);
      return;
    }

    // For "one" occurrence deletion, skip folder cleanup (event still exists)
    if (frequency_affect !== "one" && event.folder) {
      try {
        let folder = await getDocDataByRef(event.folder);
        let folder_events = await queryCollection("event", [
          {
            field: "folder",
            operator: "==",
            value: event.folder,
          },
        ]);
        console.log("Folder events:", folder_events);
        if (folder && folder_events.length <= 1) {
          await updateDocApi(
            folder.ref,
            { dateintervention: null, intervention_time_int: 0 },
            prefix
          );
        }
      } catch (err) {
        console.error("Error checking folder for event deletion:", err);
      }
    }

    {
      if (frequency_affect === "one") {
        let exception_dates = event?.exception_dates || [];
        exception_dates.push(parsed_date);
        await updateDocDataFieldApi(
          event?.ref,
          "exception_dates",
          exception_dates,
          prefix
        );
        handleClickVariant("Evènement supprimé", "success");
        setModify(false);
        setCannotClose(false);
        onDelete(event?.id);
        return;
      } else if (frequency_affect === "all") {
        setCan_fetch(true);
        await deleteDocById("event", event?.id);
        if (event?.google_event_id) {
          const token = await getOrRefreshFirebaseToken();

          await deleteGoogleCalendarEvent(
            event?.google_event_id,
            token,
            prefix
          );
        }
        onDelete(event?.id);
      } else if (frequency_affect === "following") {
        // set upper_limit_date to parsed_date
        await updateDocDataFieldApi(
          event?.ref,
          "upper_limit_date",
          parsed_date,
          prefix
        );
      } else {
        if (event?.google_event_id) {
          const token = await getOrRefreshFirebaseToken();

          await deleteGoogleCalendarEvent(event?.id, token, prefix);
        } else {
          await deleteDocById("event", event?.id);
        }
      }

      handleClickVariant("Evènement supprimé", "success");
      setModify(false);
      setCannotClose(false);
      onCloseEvent(true);
    }
  };

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };

  const handleSaveNotes = async () => {
    await updateDocDataFieldApi(event?.ref, "description", description, prefix);
    handleClickVariant("Notes enregistrées", "success");
    onUpdate();
  };

  const [nonconfrom_report_loading, setNonconform_report_loading] =
    useState(false);

  const [frequencyChangeModalOpen, setFrequencyChangeModalOpen] =
    useState(false);
  const [frequencyDeleteModalOpen, setFrequencyDeleteModalOpen] =
    useState(false);
  const [frequency_affect, setFrequencyAffect] = useState(null);
  const [loadingSave, setLoadingSave] = useState(false);

  const handleModifyEvent = async () => {
    setLoadingSave(true);

    try {
      console.log("Modifying event with id:", event_id);
      const token = await getOrRefreshFirebaseToken();
      let start_timestamp = event?.start;
      let end_timestamp = event?.end;

      const selectedTime = rangeTime.start_seconds;
      const selectedTime2 = rangeTime.end_seconds;

      // remove hours and minutes from selectedDateSeconds

      const new_start_date_seconds = selectedDateSeconds + selectedTime;
      const new_end_date_seconds = selectedDateSeconds + selectedTime2;

      start_timestamp = getFlutterTimeFromSeconds(new_start_date_seconds);
      end_timestamp = getFlutterTimeFromSeconds(new_end_date_seconds);

      if (
        [
          "daily",
          "weekly",
          "weekly2",
          "weekly3",
          "monthly",
          "weekly5",
          "weekly6",
        ].includes(event?.frequency || null) &&
        frequency_affect == null
      ) {
        setFrequencyChangeModalOpen(true);
        return;
      } else {
        if (frequency_affect === "one") {
          // Create a standalone (non-recurring) event for this single occurrence,
          // carrying ALL the new field values entered by the user.
          await createDocApi(
            "event",
            {
              ...event,
              name: name ?? event?.name ?? "",
              description: description ?? event?.description ?? "",
              address: adresse ?? event?.address ?? event?.adresse ?? "",
              adresse: adresse ?? event?.adresse ?? event?.address ?? "",
              ville: ville ?? event?.ville ?? "",
              postal: postal ?? event?.postal ?? "",
              client_id: selected_client ?? event?.client_id ?? null,
              conductor_id: selected_conductor ?? event?.conductor_id ?? null,
              members_id: selected_members ?? event?.members_id ?? [],
              pack_name: pack_name ?? event?.pack_name ?? "",
              type: selected_event_type ?? event?.type ?? "Intervention",
              documents_completed: documents_completed,
              rdv_confirmed: rdv_confirmed,
              cancelled: cancelled,
              frequency: null,
              exception_dates: [],
              upper_limit_date: null,
              start: start_timestamp,
              end: end_timestamp,
            },
            prefix
          );

          // Add this date to the original recurring event's exception_dates so this
          // occurrence is hidden from the series. Update ONLY this field —
          // we must keep every other field of the series intact.
          const new_exception_dates = [
            ...(event?.exception_dates || []),
            parsed_date,
          ];
          await updateDocDataFieldApi(
            event?.ref,
            "exception_dates",
            new_exception_dates,
            prefix
          );
        } else if (frequency_affect === "all") {
          let pack_id = selected_pack;
          let res = await modifyEvent(
            selected_members || [],
            start_timestamp,
            end_timestamp,
            dayjs(new Date(start_timestamp.seconds * 1000)).format(
              "DD/MM/YYYY"
            ),
            pack_name || "",
            pack_id,
            event?.link || "",
            event?.mandataire_auto || true,
            event?.nom_auto || true,
            event?.titre_auto || true,
            name || "",
            selected_client || "",
            event?.emails || [],
            event?.num_particulier || "",
            event?.msg_content || "",
            name || "",
            adresse || "",
            ville || "",
            postal || "",
            description || "",
            selected_folder || "",
            selected_conductor || "",
            event?.id || "",
            documents_completed,
            rdv_confirmed,
            selected_event_type || "Intervention",
            event_frequency || null,
            event?.exception_dates || [],
            token,
            prefix,
            cancelled
          );
          if (
            res.success === false &&
            userData.google_calendar &&
            res.detail === "Google Calendar not connected"
          ) {
            handleClickVariant(
              "Veuillez vous reconnecter à Google Agenda",
              "error"
            );
            navigateWorkspace("/google-calendar");
            return;
          }

          // and we need to add the exception date in the current event
        } else {
          // no frequency change, just update the current event
          let res = await modifyEvent(
            selected_members || [],
            start_timestamp,
            end_timestamp,
            dayjs(new Date(start_timestamp.seconds * 1000)).format(
              "DD/MM/YYYY"
            ),
            pack_name || "",
            selected_pack,
            event?.link || "",
            event?.mandataire_auto || true,
            event?.nom_auto || true,
            event?.titre_auto || true,
            name || "",
            selected_client || "",
            event?.emails || [],
            event?.num_particulier || "",
            event?.msg_content || "",
            name || "",
            adresse || "",
            ville || "",
            postal || "",
            description || "",
            selected_folder || "",
            selected_conductor || "",
            event?.id || "",
            documents_completed,
            rdv_confirmed,
            selected_event_type || "Intervention",
            event_frequency || null,
            event?.exception_dates || [],
            token,
            prefix,
            cancelled
          );
          console.log("Modify event response:", res);
          if (
            res.success === false &&
            userData.google_calendar &&
            res.detail === "Google Calendar not connected"
          ) {
            handleClickVariant(
              "Veuillez vous reconnecter à Google Agenda",
              "error"
            );
            navigateWorkspace("/google-calendar");
            return;
          }
        }
      }

      // add this parsed date in the current event in the field "exception_dates"

      handleClickVariant("Evènement modifié", "success");
      setModify(false);
      setCannotClose(false);
      handleFetchData(false);
      onCloseEvent(true);
    } catch (error) {
      console.error("Error modifying event:", error);
    } finally {
      setLoadingSave(false);
    }
  };

  const handleGoFolder = async (folder_id) => {
    const folder = await getDocDataById("folder", folder_id);
    if (folder) {
      navigateWorkspace(`/folder/${folder_id}`);
    } else {
      handleClickVariant("Dossier non trouvé", "error");
    }
  };

  const [controlOpen, setControlOpen] = useState(false);
  const [selectedControl, setSelectedControl] = useState(null);

  const handleSetClient = async (value) => {
    setSelected_client(value);
    const client = await getOrgById(value);
    if (!client) return;
    const workspaces = await getArrayDocDataByID(
      "workspace",
      client.workspaces_id || []
    );
    const workspace = workspaces.find(
      (workspace) => workspace.master_id === orgData.id
    );

    setWorkspace(workspace);
    const client_users = await getArrayDocDataByID(
      "user",
      client.users_id || []
    );
    setConductor_options(
      client_users.map((user) => ({
        value: user.id,
        label: user.display_name,
      }))
    );
  };

  const handleSetConductor = async (value) => {
    setSelected_conductor(value);
  };
  const [date_value, setDate_value] = useState("");
  const [reminderOpen, setReminderOpen] = useState(false);

  const [infiltreaOpen, setInfiltreaOpen] = useState(false);
  const [revisionOpen, setRevisionOpen] = useState(false);
  const [loadingControls, setLoadingControls] = useState(false);
  const [loadingFixControls, setLoadingFixControls] = useState(false);
  const [conformityOpen, setConformityOpen] = useState(false);
  // Cron-free: number of controls actually linked to this event, derived live
  // from control.event_id when the event opens. null = not yet computed.
  const [eventControlsCount, setEventControlsCount] = useState(null);

  const handleFixControlLinks = async () => {
    if (loadingFixControls) return;
    setLoadingFixControls(true);
    try {
      const result = await fixControlLinksApi(event?.id, prefix);
      if (result.fixes > 0) {
        handleClickVariant(`${result.fixes} lien(s) contrôle réparé(s)`, "success");
        // Refresh event data to get updated cid/control_ids
        const fresh_event = await getDocDataById("event", event?.id);
        if (fresh_event) setEventData(fresh_event);
      } else {
        handleClickVariant("Aucun contrôle trouvé (email envoyé)", "warning");
      }
    } catch (e) {
      handleClickVariant("Erreur: " + e.message, "error");
    }
    setLoadingFixControls(false);
  };

  // Score a control by how much real data it holds: photo count first, then
  // number of filled (non-default) fields, then last-update time.
  const controlRichness = (c) => {
    let photos = 0;
    let filled = 0;
    (c?.cochamps || []).forEach((co) => {
      (co?.champs || []).forEach((ch) => {
        const content = ch?.content;
        if (!Array.isArray(content)) return;
        if (ch.type === "img") {
          photos += content.filter(
            (u) => typeof u === "string" && u.includes("app-images-v2")
          ).length;
        } else if (ch.type === "imgtext") {
          photos += content
            .slice(1)
            .filter((u) => typeof u === "string" && u.includes("app-images-v2"))
            .length;
        } else if (
          content.some(
            (v) =>
              typeof v === "string" &&
              v.trim() &&
              v.trim().toLowerCase() !== "false"
          )
        ) {
          filled += 1;
        }
      });
    });
    let updated = 0;
    const lu = c?.lastupdated;
    if (lu) {
      if (typeof lu.seconds === "number") updated = lu.seconds;
      else if (typeof lu.toMillis === "function") updated = lu.toMillis() / 1000;
      else if (typeof lu === "string") updated = Date.parse(lu) / 1000 || 0;
    }
    return { photos, filled, updated };
  };

  // The event_id query can return several controls for one event (empty
  // skeletons + re-sync duplicates). We used to blindly open controls[0], but
  // Firestore orders by doc id, so an empty/partial control could shadow the
  // real one. Open the richest (most photos, then most filled fields, then
  // most recently updated) instead.
  const pickBestControl = (controls) =>
    controls.reduce((best, c) => {
      const r = controlRichness(c);
      const b = controlRichness(best);
      if (r.photos !== b.photos) return r.photos > b.photos ? c : best;
      if (r.filled !== b.filled) return r.filled > b.filled ? c : best;
      return r.updated > b.updated ? c : best;
    });

  const handleSelectControl = async (control_id) => {
    setLoadingControls(true);
    if (loadingControls) return;
    // Query by event_id (plain string — the clean source of truth). Every
    // control carries event_id (backfilled + written by the new app).
    let controls =
      (await queryCollection("control", [
        { field: "event_id", operator: "==", value: event?.id },
      ])) || [];
    // Transition fallback: a control just created by an OLD app version has no
    // event_id yet (the reconcile cron backfills it within ~15 min). Find it via
    // the legacy eventref so it still opens immediately. Can be removed once all
    // clients write event_id.
    if (controls.length === 0) {
      controls =
        (await queryCollection("control", [
          {
            field: "eventref",
            operator: "==",
            value: getRefFromId("event", event?.id),
          },
        ])) || [];
    }
    if (controls.length === 0) {
      handleClickVariant("Contrôle non trouvé", "error");
    } else {
      const best = pickBestControl(controls);
      const token = await getOrRefreshFirebaseToken();
      await getControlPresginedUrls(best.id, token, prefix);
      let fresh_control = await getDocDataById("control", best.id);
      handleClickVariant("Contrôle trouvé", "success");
      setSelectedControl(fresh_control);
      setControlOpen(true);
    }
    setLoadingControls(false);
  };
  if (loading) {
    return (
      <div>
        <SmallSpinner></SmallSpinner>
      </div>
    );
  }
  return (
    <div className="">
      <ConfirmationModal
        onDismiss={(confirmed) => {
          if (confirmed) {
            deleteEvent();
          } else {
            setDeleteConfirmOpen(false);
          }
        }}
        isOpen={confirm_delete_open}
        onClose={() => setDeleteConfirmOpen(false)}
        title="Confirmer la suppression"
        message="Êtes-vous sûr de vouloir supprimer cet évènement ? Cette action est irréversible."
      ></ConfirmationModal>

      <Modal1 isOpen={email_open} onClose={() => setEmailOpen(false)}>
        <EmailModal
          folderData={selected_folder_object}
          orgData={orgData}
          masterData={masterData}
          onClose={() => {
            setEmailOpen(false);
          }}
          eventData={event}
          navigateWorkspace={navigateWorkspace}
          workspaceData={workspaceData}
        ></EmailModal>
      </Modal1>

      <Modal1 isOpen={revisionOpen} onClose={() => setRevisionOpen(false)}>
        <Revisite
          folder={selected_folder_object}
          orgData={orgData}
          userData={userData}
          onClose={() => setRevisionOpen(false)}
          onUpdate={() => {}}
        />
      </Modal1>
      <Modal1 isOpen={infiltreaOpen} onClose={() => setInfiltreaOpen(false)}>
        <NewMission
          folder={selected_folder_object}
          orgData={orgData}
          userData={userData}
          onClose={() => setInfiltreaOpen(false)}
          onUpdate={() => {}}
        />
      </Modal1>
      <Modal1 isOpen={conformityOpen} onClose={() => setConformityOpen(false)}>
        <Conformity
          document={null}
          folder={selected_folder_object}
          orgData={orgData}
          onClose={() => setConformityOpen(false)}
          onUpdate={() => {}}
        />
      </Modal1>
      <Modal1 isOpen={controlOpen} onClose={() => setControlOpen(false)}>
        <Control
          first_control={selectedControl}
          onClose={() => {
            setControlOpen(false);
          }}
          setControl={setSelectedControl}
          folder={selected_folder_object}
        ></Control>
      </Modal1>
      <Modal1
        isOpen={frequencyChangeModalOpen}
        onClose={() => setFrequencyChangeModalOpen(false)}
      >
        <div className="w-c300 flex flex-col gap-2 bg-white rounded-xl p-4">
          <div className="text-h2">Modifier un évènement récurrent</div>

          <DropDownGPT03
            items={[
              {
                value: "one",
                label: "Seulement cet évènement",
              },

              {
                value: "all",
                label: "Tous les évènements",
              },
            ]}
            value={frequency_affect}
            onChange={(e) => setFrequencyAffect(e.value)}
            label={"Appliquer à"}
          ></DropDownGPT03>

          <PrimaryButton
            onClick={() => handleModifyEvent()}
            disabled={frequency_affect === null}
          >
            Confirmer
          </PrimaryButton>
        </div>
      </Modal1>
      <Modal1
        isOpen={frequencyDeleteModalOpen}
        onClose={() => setFrequencyDeleteModalOpen(false)}
      >
        <div className="w-c400 flex flex-col gap-2 bg-white rounded-xl p-4">
          <div className="text-h2">Supprimer un évènement récurrent</div>

          <DropDownGPT03
            items={[
              {
                value: "one",
                label: "Seulement cet évènement",
              },
              {
                value: "following",
                label: "Cet évènement et tous les suivants",
              },
              {
                value: "all",
                label: "Tous les évènements",
              },
            ]}
            value={frequency_affect}
            onChange={(e) => setFrequencyAffect(e.value)}
            label={"Appliquer à"}
          ></DropDownGPT03>

          <PrimaryButton
            onClick={() => deleteEvent()}
            disabled={frequency_affect === null}
          >
            Confirmer
          </PrimaryButton>
        </div>
      </Modal1>
      <Modal1 isOpen={reminderOpen} onClose={() => setReminderOpen(false)}>
        <SMSReminderModal
          folderData={selected_folder_object}
          orgData={orgData}
          masterData={masterData}
          eventData={event}
          handleRefresh={handleFetchData}
          onClose={() => setReminderOpen(false)}
          setEvent={setEventData}
          navigateWorkspace={navigateWorkspace}
        ></SMSReminderModal>
      </Modal1>
      {orgData &&
        loading === false &&
        ((modify == false && (
          <div className="w-c500 rounded-xl h-full  max-h-[80vh] overflow-y-auto">
            <div className="flex flex-row justify-between">
              <div className="text-h1 text-black"> {event?.name}</div>
              <div className="flex flex-row gap-2 items-center">
                {event.revision && (
                  <Tippy
                    content="Cet évènement est une revisite"
                    className="custom-tooltip"
                    placement="top"
                    delay={500}
                  >
                    <div className="flex flex-row gap-1 items-center">
                      <Icon1
                        icon_name="restauration"
                        fill={"#6366f1"}
                        size={20}
                      ></Icon1>
                      <div className=" text-h3 text-shadow_50">
                        {event.revision.replace("Non conformité ", "")}
                      </div>
                    </div>
                  </Tippy>
                )}
                <Tippy
                  content="Evènement récurrent"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <Icon1
                      icon_name="restart"
                      fill={
                        [
                          "daily",
                          "weekly",
                          "weekly2",
                          "weekly3",
                          "monthly",
                          "weekly5",
                          "weekly6",
                        ].includes(event.frequency)
                          ? "#6366f1"
                          : "transparent"
                      }
                      size={20}
                    ></Icon1>{" "}
                  </div>
                </Tippy>
                <Tippy
                  content="Rendez-vous confirmé"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <Icon1
                      icon_name="done3"
                      fill={event.rdv_confirmed ? "#6366f1" : "lightgrey"}
                      size={20}
                    ></Icon1>{" "}
                  </div>
                </Tippy>
                <Tippy
                  content="Test annulé"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <Icon1
                      icon_name="cancel"
                      fill={event.cancelled ? "#ef4444" : "lightgrey"}
                      size={20}
                    ></Icon1>{" "}
                  </div>
                </Tippy>
                <Tippy
                  content="Dossier créé"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <Icon1
                      icon_name="folder"
                      fill={event.folder ? "#6366f1" : "lightgray"}
                      size={20}
                    ></Icon1>{" "}
                  </div>
                </Tippy>

                <Tippy
                  content="Documents complétés"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <Icon1
                      icon_name="document"
                      fill={event.documents_completed ? "#6366f1" : "lightgrey"}
                      size={20}
                    ></Icon1>{" "}
                  </div>
                </Tippy>
                <Tippy
                  content="Rappel programmé"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <Icon1
                      icon_name="cloche"
                      fill={event.reminder ? "#6366f1" : "lightgrey"}
                      size={20}
                    ></Icon1>{" "}
                  </div>
                </Tippy>
                <Tippy
                  content="Contrôle réalisé"
                  className="custom-tooltip"
                  placement="top"
                  delay={500}
                >
                  <div>
                    <Icon1
                      icon_name="control"
                      fill={eventControlsCount > 0 || event.controls_count > 0 || event.cid ? "#6366f1" : "lightgrey"}
                      size={20}
                    ></Icon1>{" "}
                  </div>
                </Tippy>
              </div>
            </div>
            <Space y={20} />
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150 "> Date </div>
              <span className="text-shadow_50">
                {" "}
                {moment(new Date(event?.start.seconds * 1000)).format(
                  "DD/MM/YYYY HH:mm"
                )}
                -{moment(new Date(event?.end.seconds * 1000)).format("HH:mm")}
              </span>
            </div>
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150"> Type </div>
              <span className="text-shadow_50"> {event.type}</span>
            </div>
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150"> Dossier </div>
              <span className="text-shadow_50">
                {" "}
                {selected_folder_object?.nom}
              </span>
            </div>
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150"> Téléphone </div>
              <span className="text-shadow_50">
                {" "}
                {selected_folder_object?.reglement?.infos?.phone ||
                  selected_folder_object?.particulier?.phone}
              </span>
            </div>
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150"> Client </div>
              <span className="text-shadow_50">
                {selected_folder_object?.client_type === "particulier"
                  ? "Particulier"
                  : selected_client_idbject?.name}
              </span>
            </div>
            {selected_folder_object && (
              <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
                <div className="text-shadow_50 w-c150"> Prestation </div>
                <span className="text-shadow_50">
                  {" "}
                  {selected_folder_object?.pack_name}
                </span>
              </div>
            )}
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150"> Ville </div>
              <span className="text-shadow_50"> {event?.ville}</span>
            </div>
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150"> Code postal </div>
              <span className="text-shadow_50"> {event?.postal}</span>
            </div>
            <div className="text-h3 flex flex-row gap-2 border-b-1 border-shadow_5">
              <div className="text-shadow_50 w-c150"> Adresse </div>
              <span className="text-shadow_50"> {event?.address}</span>
            </div>
            <span className="text-h3 black gap-2 flex flex-row  border-b-1 border-shadow_5">
              <span className="w-c150 text-shadow_50"> Membres</span>

              <span className="flex flex-col ">
                {selected_members_objects.map((user) => (
                  <div key={user?.id} className="flex flex-row gap-2">
                    <div className="text-shadow_50">
                      {user?.id
                        ? `${user.display_name}`
                        : "Email not available"}
                    </div>
                  </div>
                ))}
              </span>
            </span>
            {selected_folder_object?.folder_type !== "audit" && (
              <span className="text-h3 black gap-2 flex flex-row  ">
                <span className="w-c150 text-shadow_50">
                  {" "}
                  Conducteur chantier
                </span>

                <span className="flex flex-col ">
                  {clientmember?.display_name && (
                    <div className="flex flex-row gap-2">
                      <div className="text-shadow_50">
                        {clientmember?.display_name}
                      </div>
                    </div>
                  )}
                </span>
              </span>
            )}
            {event?.link && (
              <div className="text-h3 flex flex-row gap-2  border-b-1 border-shadow_5">
                <div className="text-black w-c70"> Lien </div>
                <span className="text-shadow_50"> {event?.link}</span>
              </div>
            )}{" "}
            {true && (
              <div className="mt-8 flex flex-col gap-1">
                <div className="flex flex-row justify-between  items-center  border-b-1 border-shadow_5">
                  {" "}
                  <div className="flex flex-row gap-2">
                    {" "}
                    <Icon1
                      icon_name="control"
                      fill={eventControlsCount > 0 || event.controls_count > 0 || event.cid ? "#6366f1" : "lightgrey"}
                      size={18}
                    ></Icon1>{" "}
                    <div className="text-h3 text-shadow_50">Contrôle</div>
                  </div>{" "}
                  <div className="flex flex-row gap-2">
                    <SecondaryButton
                      className="h-6"
                      disabled={workspaceData || !event?.folder}
                      onClick={() => setConformityOpen(true)}
                    >
                      Générer rapport
                    </SecondaryButton>
                    <SecondaryButton
                      disabled={workspaceData}
                      className="h-6"
                      onClick={handleFixControlLinks}
                    >
                      Trouver contrôle{" "}
                      {loadingFixControls && <SmallSpinner></SmallSpinner>}
                    </SecondaryButton>
                    <SecondaryButton
                      disabled={
                        workspaceData ||
                        !(eventControlsCount > 0 || event?.controls_count > 0 || event?.cid)
                      }
                      className="h-6"
                      onClick={() => handleSelectControl(event?.cid)}
                    >
                      Voir contrôles{" "}
                      {loadingControls && <SmallSpinner></SmallSpinner>}
                    </SecondaryButton>
                  </div>{" "}
                </div>
                <div className="flex flex-row justify-between items-center  border-b-1 border-shadow_5">
                  <div className="flex flex-row gap-2">
                    <Icon1
                      icon_name="folder"
                      fill={event.folder ? "#6366f1" : "lightgray"}
                      size={18}
                    ></Icon1>{" "}
                    <div className="text-h3 text-shadow_50">Dossier</div>
                  </div>
                  <div className="text-h3 text-shadow_50"></div>
                  <div className="flex flex-row gap-2">
                    {!event?.folder && (
                      <SecondaryButton
                        className="h-6"
                        onClick={handleGoNewFolder}
                        disabled={workspaceData}
                      >
                        Créer dossier
                      </SecondaryButton>
                    )}

                    {event?.folder && (
                      <SecondaryButton
                        className="h-6"
                        onClick={() => handleGoFolder(event?.folder.id)}
                      >
                        Voir dossier
                      </SecondaryButton>
                    )}
                  </div>
                </div>
                <div className="flex flex-row justify-between items-center  border-b-1 border-shadow_5">
                  <div className="flex flex-row gap-2">
                    <Icon1
                      icon_name="restauration"
                      fill={event.revision ? "#6366f1" : "lightgray"}
                      size={18}
                    ></Icon1>{" "}
                    <div className="text-h3 text-shadow_50">
                      Revisite {event.revision || ""}
                    </div>
                  </div>
                  <div className="text-h3 text-shadow_50"></div>
                  <div className="flex flex-row gap-2">
                    {event?.folder && (
                      <SecondaryButton
                        className="h-6"
                        disabled={workspaceData}
                        onClick={() => setRevisionOpen(true)}
                      >
                        Créer une nouvelle revisite
                      </SecondaryButton>
                    )}
                  </div>
                </div>
                <div className="flex flex-row justify-between items-center  ">
                  <div className="flex flex-row gap-2">
                    <Icon1
                      icon_name="cloche"
                      fill={event.reminder ? "#6366f1" : "lightgrey"}
                      size={18}
                    ></Icon1>{" "}
                    <div className="text-h3 text-shadow_50">Rappel sms</div>
                  </div>
                  <div className="flex flex-row gap-2 justify-end ">
                    <div className="flex flex-row gap-2 ">
                      <div
                        className={`text-h3 rounded-lg px-2 py-0.5 flex flex-row gap-2`}
                      >
                        {event?.reminder?.status === "sent"
                          ? "Envoyé"
                          : event?.reminder?.status === "wait"
                            ? "Programmé"
                            : "Non défini"}
                        {event?.reminder?.status === "sent" ? (
                          <Icon1
                            icon_name="done2"
                            fill="#11ef80"
                            size={18}
                          ></Icon1>
                        ) : event?.reminder?.status === "wait" ? (
                          <Icon1
                            icon_name="horloge"
                            fill="orange"
                            size={18}
                          ></Icon1>
                        ) : (
                          <></>
                        )}
                      </div>{" "}
                    </div>
                    <SecondaryButton
                      className="h-6"
                      onClick={() => setReminderOpen(true)}
                      disabled={workspaceData}
                    >
                      {event?.reminder?.status === "sent"
                        ? "Voir rappel"
                        : event?.reminder?.status === "wait"
                          ? "Modifier rappel"
                          : "Définir rappel"}
                    </SecondaryButton>
                  </div>{" "}
                </div>{" "}
                <div className="flex flex-row justify-between items-center  ">
                  <div className="flex flex-row gap-2">
                    <Icon1 icon_name="email" fill="lightgrey" size={18}></Icon1>{" "}
                    <div className="text-h3 text-shadow_50">Envoyer email</div>
                  </div>
                  <div className="flex flex-row gap-2 justify-end ">
                    <SecondaryButton
                      className="h-6"
                      onClick={() => setEmailOpen(true)}
                      disabled={
                        workspaceData || !selected_folder_object || !masterData
                      }
                    >
                      Envoyer email
                    </SecondaryButton>
                  </div>{" "}
                </div>
                <Space y={20} />
                <div className="flex flex-row justify-between items-end">
                  <div className="text-h6 text-shadow_25 ">
                    event_id : {event.id}
                  </div>
                  <PrimaryButton
                    disabled={isEventAdmin(orgData, event) ? false : true}
                    className="h-6"
                    onClick={() => {
                      setModify(true);
                      setCannotClose(true);
                    }}
                    startIcon={
                      <Icon1 icon_name="modify" fill="white" size={18}></Icon1>
                    }
                  >
                    Modifier
                  </PrimaryButton>
                </div>
              </div>
            )}
          </div>
        )) ||
          (modify === true && (
            <div className="w-c700 flex flex-col gap-2 h-full  max-h-[80vh] overflow-y-auto">
              <div className="w-full flex flex-row  gap-6 h-full">
                <div className="w-1/2 flex flex-col gap-2 h-full ">
                  <TextField3
                    label="Titre"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  ></TextField3>
                  <div
                    className=""
                    onClick={(e) => {
                      e.stopPropagation();
                      if (folderModalOpen === false) {
                        setFolderModalOpen(true);
                        setSearchValue(
                          selected_folder_object
                            ? selected_folder_object.nom
                            : ""
                        );
                      }
                    }}
                  >
                    {folderModalOpen === false ? (
                      <TextField2T
                        value={selected_folder_object?.nom || ""}
                        label="Dossier"
                      ></TextField2T>
                    ) : (
                      <SearchAlgolia
                        options={algoliaResults.map((result) => ({
                          label: result.nom,
                          value: result.objectID,
                          extra_label: result.marque,
                          extra_label_2: result.ville,
                        }))}
                        focus_on_start={true}
                        visible_empty={true}
                        inputValue={searchValue}
                        setInputValue={(value) => handleQuerySearch(value)}
                        placeholder="Rechercher un dossier ..."
                        onAction={(newValue) => {
                          handleSetFolder(newValue.value);
                          setFolderModalOpen(false);
                          setSearchValue("");
                        }}
                        classNameCustom="w-c300"
                      ></SearchAlgolia>
                    )}
                  </div>

                  <DropDownGPT03
                    label="Type d'évènement"
                    value={selected_event_type}
                    disabled={selected_folder ? true : false}
                    items={event_type_options}
                    onChange={(e) => {
                      setName(e.value);
                      setSelected_event_type(e.value);
                    }}
                  ></DropDownGPT03>
                  <Space y={20} />
                  <div className="h-full w-full ">
                    <DatePickerGPT0
                      onChange={setSelectedDateSeconds}
                      seconds={selectedDateSeconds}
                      format="DD/MM/YYYY"
                      className="w-full"
                      label="Sélectionner la date d'intervention"
                    ></DatePickerGPT0>
                    {/* Time Picker */}
                    <Space y={10} />
                    <RangeTimePickerGPT0
                      remove_1_hour={true}
                      onChange={handleTimeRangeChange}
                      value={rangeTime}
                    ></RangeTimePickerGPT0>
                  </div>
                  <DropDownGPT03
                    label="Fréquence"
                    value={event_frequency}
                    items={[
                      {
                        value: null,
                        label: "Ponctuel",
                      },
                      {
                        value: "daily",
                        label: "Tous les jours",
                      },
                      {
                        value: "weekly",
                        label: "Toutes les semaines",
                      },
                      {
                        value: "weekly2",
                        label: "Toutes les 2 semaines",
                      },
                      {
                        value: "weekly3",
                        label: "Toutes les 3 semaines",
                      },
                      {
                        value: "monthly",
                        label: "Toutes les 4 semaines",
                      },
                      {
                        value: "weekly5",
                        label: "Toutes les 5 semaines",
                      },
                      {
                        value: "weekly6",
                        label: "Toutes les 6 semaines",
                      },
                    ]}
                    onChange={(e) => {
                      setEventFrequency(e.value);
                    }}
                  ></DropDownGPT03>
                  <TextField2T
                    label="Adresse"
                    value={adresse}
                    onChange={(e) => setAdresse(e.target.value)}
                  ></TextField2T>
                  <TextField2T
                    label="Ville"
                    value={ville}
                    onChange={(e) => setVille(e.target.value)}
                  ></TextField2T>
                  <TextField2T
                    label="Code postal"
                    value={postal}
                    onChange={(e) => setPostal(e.target.value)}
                  ></TextField2T>
                </div>

                <div className="w-1/2 flex flex-col gap-2 pt-8">
                  <DropDownGPTS3
                    label="Prestation"
                    value={selected_pack}
                    items={pack_options}
                    disabled={selected_folder ? true : false}
                    onChange={(e) => setSelected_pack(e.value)}
                    resetValue={() => setSelected_pack(null)}
                  ></DropDownGPTS3>
                  {selected_folder_object?.client_type === "particulier" && (
                    <DropDownGPTS3
                      label="Client"
                      value={"particulier"}
                      items={[
                        {
                          value: "particulier",
                          label: "Particulier",
                        },
                      ]}
                      disabled={true}
                    ></DropDownGPTS3>
                  )}
                  {selected_folder_object?.client_type != "particulier" && (
                    <div className="relative flex flex-row gap-2 items-center">
                      <DropDownGPTS3
                        label="Client"
                        value={selected_client}
                        items={clients_options}
                        disabled={selected_folder ? true : false}
                        onChange={(e) => handleSetClient(e.value)}
                      ></DropDownGPTS3>
                      {workspace?.emoji && (
                        <div className="text-1 absolute right-2">
                          {workspace?.emoji}
                        </div>
                      )}
                    </div>
                  )}

                  <div className="flex flex-row gap-1 items-center">
                    <Icon1
                      icon_name="done3"
                      fill={rdv_confirmed ? "#6366f1" : "lightgrey"}
                      size={20}
                    ></Icon1>
                    <div className="text-h3 text-shadow_50 ml-2">
                      RDV confirmé
                    </div>{" "}
                    <EasySwitch
                      checked={rdv_confirmed}
                      onChange={(checked) => setRdv_confirmed(checked)}
                    />
                  </div>
                  <div className="flex flex-row gap-1 items-center">
                    <Icon1
                      icon_name="document"
                      fill={documents_completed ? "#6366f1" : "lightgrey"}
                      size={20}
                    ></Icon1>

                    <div className="text-h3 text-shadow_50 ml-2">
                      Documents complétés
                    </div>
                    <EasySwitch
                      checked={documents_completed}
                      onChange={(checked) => setDocuments_completed(checked)}
                    />
                  </div>
                  <div className="flex flex-row gap-1 items-center">
                    <Icon1
                      icon_name="cancel"
                      fill={cancelled ? "#ef4444" : "lightgrey"}
                      size={20}
                    ></Icon1>
                    <div className="text-h3 text-shadow_50 ml-2">
                      Test annulé
                    </div>
                    <EasySwitch
                      checked={cancelled}
                      onChange={(checked) => setCancelled(checked)}
                    />
                  </div>
                  {selected_folder_object?.folder_type !== "audit" && (
                    <DropDownGPT03
                      label="Conducteur de chantier"
                      value={selected_conductor}
                      items={conductor_options}
                      onChange={(e) => handleSetConductor(e.value)}
                    ></DropDownGPT03>
                  )}
                  <DropDownGPTM3
                    label="Membres"
                    value={selected_members}
                    items={members_options}
                    onChange={(e) => setSelected_members(e)}
                    maxHeight="200px"
                  ></DropDownGPTM3>
                  <div className="flex flex-row justify-between"> </div>
                  <div className="">
                    <Tippy
                      content="Notes de l'évènement"
                      className="custom-tooltip"
                      placement="top"
                      delay={500}
                    >
                      <div>
                        <MLTFGPT1
                          value={description}
                          onChange={(e) => setDescription(e.target.value)}
                        ></MLTFGPT1>
                      </div>
                    </Tippy>
                  </div>
                  {selected_client_idbject?.id && (
                    <Tippy
                      content="Notes du client"
                      className="custom-tooltip"
                      placement="top"
                      delay={500}
                    >
                      <div className="max-w-c400">
                        <NotesClient
                          disabled={true}
                          userData={userData}
                          orgData={orgData}
                          workspaceData={workspace}
                          onUpdate={() => {}}
                        ></NotesClient>
                      </div>
                    </Tippy>
                  )}
                </div>
              </div>
              <Space y={10} />
              <div className="flex flex-row w-full justify-between pb-1">
                <div className="flex flex-row gap-4 ">
                  {temporary && (
                    <SecondaryButton onClick={deleteEvent}>
                      Annuler et supprimer
                    </SecondaryButton>
                  )}
                  {!temporary && (
                    <SecondaryButton
                      onClick={() => {
                        setCannotClose(false);
                        onCloseEvent(true);
                      }}
                    >
                      Fermer
                    </SecondaryButton>
                  )}
                  {!temporary && (
                    <SecondaryButton onClick={() => setDeleteConfirmOpen(true)}>
                      Supprimer
                    </SecondaryButton>
                  )}
                </div>
                <PrimaryButton onClick={() => handleModifyEvent()}>
                  Enregistrer {loadingSave && <SmallSpinner></SmallSpinner>}
                </PrimaryButton>
              </div>
            </div>
          )))}
    </div>
  );
};

export default Event;
